export function Footer() {
  return (
    <footer className="mt-16 border-t border-border px-4 py-8 text-muted-foreground">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="text-base font-semibold text-foreground">Platanus Track</p>
        <p className="text-sm">&copy; {new Date().getFullYear()}</p>
      </div>
    </footer>
  )
}
